import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import __isEmpty from 'lodash/isEmpty';

import { getCurrentUser } from '../../../services/parse';

export default function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({location}) =>
        !__isEmpty(getCurrentUser()) ? (
          children
        ) : (
          <Redirect to={{pathname: '/login', state: { from: location }}} />
        )
      }
    />
  );
}
